export const PRICING_COLUMN_TYPES = {
  DESCRIPTION: 'description',
  PRICE: 'price',
  QUANTITY: 'quantity',
  SUBTOTAL: 'subtotal',
  FEE: 'fee',
  TAX: 'tax',
  DISCOUNT: 'discount',
  TOTAL: 'total'
};

export const PRICING_COLUMN_CELL_VALUE_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  AMOUNT: 'amount',
  PERCENT: 'percent'
};

// Map column types to their corresponding value types
export const COLUMN_TYPE_TO_VALUE_TYPE = {
  [PRICING_COLUMN_TYPES.DESCRIPTION]: PRICING_COLUMN_CELL_VALUE_TYPES.TEXT,
  [PRICING_COLUMN_TYPES.PRICE]: PRICING_COLUMN_CELL_VALUE_TYPES.AMOUNT,
  [PRICING_COLUMN_TYPES.QUANTITY]: PRICING_COLUMN_CELL_VALUE_TYPES.NUMBER,
  [PRICING_COLUMN_TYPES.SUBTOTAL]: PRICING_COLUMN_CELL_VALUE_TYPES.AMOUNT,
  [PRICING_COLUMN_TYPES.FEE]: PRICING_COLUMN_CELL_VALUE_TYPES.AMOUNT,
  [PRICING_COLUMN_TYPES.TAX]: PRICING_COLUMN_CELL_VALUE_TYPES.AMOUNT,
  [PRICING_COLUMN_TYPES.DISCOUNT]: PRICING_COLUMN_CELL_VALUE_TYPES.PERCENT,
  [PRICING_COLUMN_TYPES.TOTAL]: PRICING_COLUMN_CELL_VALUE_TYPES.AMOUNT
};

export const PRICING_COLUMN_CELL_DEFAULT_ROW_VALUES = {
  [PRICING_COLUMN_TYPES.DESCRIPTION]: { value: '' },
  [PRICING_COLUMN_TYPES.PRICE]: { value: '0.00' },
  [PRICING_COLUMN_TYPES.QUANTITY]: { value: '1' },
  [PRICING_COLUMN_TYPES.DISCOUNT]: { value: '0' },
  [PRICING_COLUMN_TYPES.SUBTOTAL]: { value: '$0.00' },
  [PRICING_COLUMN_TYPES.FEE]: { value: '0' },
  [PRICING_COLUMN_TYPES.TAX]: { value: '0' },
  [PRICING_COLUMN_TYPES.TOTAL]: { value: '0' }
};
